import StakeItem from './StakeItem';

export default StakeItem;
